/// <reference types="vite/client" />
import React from 'react';
import Routes from './Routes';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import Airbrake from './Airbrake';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from 'styled-components';
import { client } from './utils/apollo/client';
import { store } from './utils/redux/store';
import { styledTheme } from './utils/styles/styledTheme';

const muiTheme = getMuiTheme({
  fontFamily: 'Heebo, sans-serif',
  palette: {
    primary1Color: '#278ADA', // blue
    primary2Color: '#278ADA', // blue
    primary3Color: '#466B88', // cobalt
    accent1Color: '#8FA9BE', // darkgrey
    accent2Color: '#C1CDD7', // meddarkgrey
    accent3Color: '#E0E5E9', // medlightgrey
    textColor: '#0E2C44', // darkblue
    alternateTextColor: '#FFFFFF', // white
    canvasColor: '#FFFFFF', // white
    borderColor: '#FFFFFF00', // rgba(7,24,39,.85)
    disabledColor: '#C1CDD7', // meddarkgrey
    pickerHeaderColor: '#278ADA', // blue
    clockCircleColor: '#E0E5E9', // medlightgrey
    shadowColor: '#FFFFFF00', // rgba(7,24,39,.85)
  },
  overlay: {
    backgroundColor: 'rgba(7,24,39,.85)', // navyblue @ 85%
  },
  ripple: {
    color: '#FFFFFF00',
  },
});

const Root = () => (
  <Airbrake>
    <ApolloProvider client={client}>
      <Provider store={store}>
        <ThemeProvider theme={styledTheme}>
          <MuiThemeProvider muiTheme={muiTheme}>
            <IntlProvider locale='en'>
              <Routes store={store} />
            </IntlProvider>
          </MuiThemeProvider>
        </ThemeProvider>
      </Provider>
    </ApolloProvider>
  </Airbrake>
);

export default Root;
